/**
 * Authors: mariushirjanu, Triadi
 * Created: 29/07/2020
 * Upgraded: 28/10/2022
 */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';
import { Transition } from '@uirouter/angular';
import { GaWizard, IWizardStep } from '../../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { WizardDemoAppComponent } from './wizard-demo-app.component';
import { WizardDemoTestAppComponent } from './wizard-test-app.component';
import { WIZARD_DEMO } from '../../../shared/app-wizards';
import { ITranslateText } from '../../../shared/wizard/wizard-wrapper.component';

@Component({
  selector: 'wizard-demo',
  template: `
    <wizard-wrapper [wizardTitle]="title" [loading]="loading" [wizardId]="wizardId" [showProgress]="true" [progress]="25"></wizard-wrapper>
  `
})
export class WizardDemoComponent implements OnInit, OnDestroy {
  public loading:ITranslateText = {
    translateValues: { toload: 'Demo' }
  };
  public title:string = 'Wizard Test';
  private wizard:GaWizard;
  public wizardId:string = WIZARD_DEMO;

  constructor(
    private transition:Transition,
    private wizardService:GaWizardService
  ) {
    // if wizard id is provided then isolate instance of wizard services
    this.wizard = this.wizardService.getInstance(WIZARD_DEMO);
  }

  private initWizardSetup():void {
    const wizardSteps:IWizardStep[] = [];
    const params:IObject = this.transition.params();

    wizardSteps.push(
      this.wizardService.createStep('wizarddemoapp', 'Wizard Demo App', WizardDemoAppComponent, 'main.demo.wizard.demoapp', params, undefined, true),
      this.wizardService.createStep('wizardtestapp', 'Wizard Test App', WizardDemoTestAppComponent, 'main.demo.wizard.testapp', params, undefined, true)
    );

    this.wizard.steps(wizardSteps);
    this.wizard.sync();
  }

  public ngOnInit():void {
    this.initWizardSetup();
    // display loading spinner for 1 sec
    setTimeout(() => {
      this.loading = undefined;
    }, 1000);
  }

  public ngOnDestroy():void {
    this.wizard.clear();
  }
}